export default __webpack_public_path__ + "e060f69c14c44bd67afb436bad51caa7.png";